import { C } from "../../lib/constants";

export const Inp = ({label, type="text", placeholder, value, onChange, icon}) => (
  <div style={{marginBottom:16}}>
    {label&&<div style={{color:C.sub,fontSize:11,fontWeight:700,letterSpacing:0.8,textTransform:"uppercase",marginBottom:6}}>{label}</div>}
    <div style={{position:"relative"}}>
      {icon&&<span style={{position:"absolute",left:14,top:"50%",transform:"translateY(-50%)",fontSize:16}}>{icon}</span>}
      <input type={type} placeholder={placeholder} value={value} onChange={onChange}
        style={{width:"100%",background:C.surface,border:`1.5px solid ${C.border}`,borderRadius:12,padding:icon?"13px 14px 13px 42px":"13px 16px",color:C.text,fontSize:14,boxSizing:"border-box",outline:"none",fontFamily:"-apple-system,BlinkMacSystemFont,'Segoe UI',sans-serif",boxShadow:"0 1px 3px rgba(0,0,0,0.05)"}}
        onFocus={e=>e.target.style.borderColor=C.accent} onBlur={e=>e.target.style.borderColor=C.border}/>
    </div>
  </div>
);
